module.exports = __webpack_public_path__ + "img/forwarded-v2.5a58f774.svg";